import { useEffect, useRef, useState } from "react";
export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);
  return online;
}

export function errorMessage(error: unknown) {
  return error instanceof Error ? error.message : "Request failed. Try again.";
}

/** Refresh untouched fields while keeping an edit staged against its previous server value. */
export function useStagedValue<T extends string | number>(incoming: T) {
  const [staged, setStaged] = useState(incoming);
  const previous = useRef(incoming);
  useEffect(() => {
    const baseline = previous.current;
    previous.current = incoming;
    setStaged((current) => (Object.is(current, baseline) ? incoming : current));
  }, [incoming]);
  return [staged, setStaged] as const;
}
